import React, { ChangeEvent, FC, FormEvent } from "react";

import { EmployeeSurveyQuestionDetail } from "~/components/organisms";

import {
  EmployeeSurveyWithQuestionsType,
  SelectedSharedOption,
  FormEmployeeSurveySubmissionAnswerType,
} from "~/domains";

import { BorderedTitle, Form, FormSubmitButton } from "~/ui";
import { DatePicker, LabelWithCheckBox } from "~/ui";

type PropsType = {
  employeeSurvey: EmployeeSurveyWithQuestionsType;
  className?: string;
  shareable: boolean;
  answers: FormEmployeeSurveySubmissionAnswerType[];
  isSubmitting: boolean;
  postDate: Date;
  onChangePostDate: (date: Date) => void;
  onChangeShareable: (e: ChangeEvent<HTMLInputElement>) => void;
  onChangeAnswer: (value: string | undefined, questionId: string) => void;
  handleSubmit: (e: FormEvent<HTMLFormElement>) => void;
};

export const EmployeeSurveyDetail: FC<PropsType> = ({
  employeeSurvey,
  className = "",
  shareable,
  postDate,
  answers,
  isSubmitting,
  onChangePostDate,
  onChangeAnswer,
  onChangeShareable,
  handleSubmit,
}: PropsType) => {
  return (
    <div className={className}>
      <BorderedTitle title={employeeSurvey.title} />
      {employeeSurvey.description && (
        <h3 className="mt-6 text-secondary-900 border border-solid border-secondary-400 w-full py-2 px-3 rounded">
          {employeeSurvey.description}
        </h3>
      )}
      <Form onSubmit={handleSubmit}>
        <DatePicker
          selectDate={postDate}
          onChange={onChangePostDate}
          shadow-xl
          parentClassName="mt-6"
        />
        <div className="mt-12 space-y-8 px-4">
          {employeeSurvey.employeeSurveyQuestions
            .sort((a, b) => a.displayOrder - b.displayOrder)
            .map((question) => (
              <EmployeeSurveyQuestionDetail
                key={question.id}
                options={question.employeeSurveyQuestionOptions || []}
                answers={answers.map((a) => ({
                  questionId: a.employeeSurveyQuestionId,
                  optionId: a.employeeSurveyQuestionOptionId,
                  answer: a.answer,
                }))}
                onChangeAnswer={onChangeAnswer}
                question={question}
                displayImage
              />
            ))}
        </div>
        <div className="mt-12">
          <LabelWithCheckBox
            labelText="シェア可能"
            name="share"
            labelEnd
            checked={shareable}
            onChange={onChangeShareable}
            disabled={
              employeeSurvey.answerShareOption.type !==
              SelectedSharedOption.type
            }
          />
        </div>
        <FormSubmitButton
          color="primary"
          value="投稿する"
          className="w-full mt-4"
          size="md"
          isReadOnly={isSubmitting}
        />
      </Form>
    </div>
  );
};
